var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsersquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.7916 45.4166C35.9582 45.9582 33.7916 46.2082 31.2499 46.2082H18.7499C16.2083 46.2082 14.0416 45.9582 12.2083 45.4166C12.6666 39.9999 18.2291 35.729 24.9999 35.729C31.7707 35.729 37.3332 39.9999 37.7916 45.4166Z",
    stroke: "#5E6AD2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2501 4.54175H18.7501C8.33341 4.54175 4.16675 8.70841 4.16675 19.1251V31.6251C4.16675 39.5001 6.54175 43.8126 12.2084 45.4167C12.6667 40.0001 18.2292 35.7292 25.0001 35.7292C31.7709 35.7292 37.3334 40.0001 37.7917 45.4167C43.4584 43.8126 45.8334 39.5001 45.8334 31.6251V19.1251C45.8334 8.70841 41.6667 4.54175 31.2501 4.54175ZM25.0001 29.8959C20.8751 29.8959 17.5417 26.5418 17.5417 22.4168C17.5417 18.2918 20.8751 14.9584 25.0001 14.9584C29.1251 14.9584 32.4584 18.2918 32.4584 22.4168C32.4584 26.5418 29.1251 29.8959 25.0001 29.8959Z",
    stroke: "#5E6AD2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4584 22.4166C32.4584 26.5416 29.1251 29.8957 25.0001 29.8957C20.8751 29.8957 17.5417 26.5416 17.5417 22.4166C17.5417 18.2916 20.8751 14.9583 25.0001 14.9583C29.1251 14.9583 32.4584 18.2916 32.4584 22.4166Z",
    stroke: "#5E6AD2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersquare);
export default __webpack_public_path__ + "static/media/usersquare.b7c04cd7373551fefb24f25b182c4959.svg";
export { ForwardRef as ReactComponent };